import cardTemplate from '../templates/card.hbs';
import cardEllipsisTemplate from '../templates/cardEllipsis.hbs';
import $ from 'jquery';
/**
 * card Class
 * @param {Object} data
 *      data.icon = font-awesome class for card icon
 *      data.img || data.image = url for card visual image
 *      data.url = link for title portion of card
 *      data.title = link text for url
 *      data.status = status indicator for the card ['published', 'draft']
 * @returns {Object} jQuery
 */
$.fn.sdaCard = function(data = {}) {
    const that = this;
    const $menuContent = $(that.find('.card-menu-content').html()).clone();
    const content = that.find('.card-info-content').html();
    const visualContent = that.find('.card-visual-content').addClass('card-visual');

    if (that.is('[data-compiled]')) {
        return that;
    }
    $.extend(data, that.data());

    if (content) {
        data.htmlContent = content.trim();
    }

    // If this is not a graphic card include the status card

    if (that.hasClass('sda-card')) {
        data.statusCard = true;
        data.noStatus = true;
    }

    that.html($(cardTemplate(data)))
        .find('.sda-status-card')
        .sdaStatusCard(data)
        .find('.card-menu')
        .remove();

    const $menu = that.find('.card-menu');

    if ($menuContent && $menuContent.length) {
        that.find('.card-menu')
            .html($menuContent)
            .append(cardEllipsisTemplate());

        that.find('.card-ellipsis').on('click', function() {
            $('.card-menu-open')
                .not($menu)
                .removeClass('card-menu-open');
            $menu.toggleClass('card-menu-open');
        });
    } else {
        $menu.remove();
        that.find('.card-ellipsis').remove();
    }

    if (visualContent && visualContent.length) {
        that.find('.card-visual').replaceWith(visualContent);
    }

    that.attr('data-compiled', '');

    return that;
};
